import React from "react";

interface RuleDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  rule: any;
}

const statusColor = (enabled: boolean) =>
  enabled ? "text-[#03C668] bg-[#0B3C1A]" : "text-[#C60303] bg-[#2A1313]";

const RuleDetailsModal: React.FC<RuleDetailsModalProps> = ({
  isOpen,
  onClose,
  rule,
}) => {
  if (!isOpen || !rule) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center font-manrope justify-center bg-black bg-opacity-80">
      <div className="bg-[#0D0D0D] rounded-2xl w-full max-w-lg p-0 shadow-lg relative">
        {/* Header */}
        <div className="flex justify-between items-center px-8 pt-8 pb-4">
          <h2 className="text-white text-lg font-bold">Rule Details</h2>
          <button
            onClick={onClose}
            className="text-[#60B7F6] text-base font-semibold"
          >
            Close
          </button>
        </div>
        {/* Main Card */}
        <div className="px-6 pb-6 mt-4">
          {/* Details Grid */}
          <div className=" rounded-xl  grid grid-cols-2 gap-y-4 gap-x-6">
            <div className="text-[#AEBCC6] text-[15px]">Name</div>
            <div className="text-white text-[15px] text-right font-semibold">
              {rule.name}
            </div>

            <div className="text-[#AEBCC6] text-[15px]">Type</div>
            <div className="text-white text-[15px] text-right font-semibold">
              {rule.category}
            </div>
            <div className="text-[#AEBCC6] text-[15px]">Status</div>
            <div className="flex justify-end">
              <div
                className="w-[80px] px-3 py-1 flex justify-center items-center rounded-full text-xs font-bold mt-1 "
                style={{
                  background: rule.isEnabled ? "#0B3C1A" : "#2A1313",
                  color: rule.isEnabled ? "#03C668" : "#C60303",
                }}
              >
                {rule.isEnabled ? "Active" : "Disabled"}
              </div>
            </div>
            <div className="text-[#AEBCC6] text-[15px]">Trigger Logic</div>
            <div className="text-white text-[15px] text-right font-semibold">
              {rule.notes}
            </div>
            <div className="text-[#AEBCC6] text-[15px]">Condition Type</div>
            <div className="text-white text-[15px] text-right font-semibold">
              {rule.condition?.type}
            </div>
            <div className="text-[#AEBCC6] text-[15px]">Operator</div>
            <div className="text-white text-[15px] text-right font-semibold">
              {rule.condition?.operator}
            </div>
            <div className="text-[#AEBCC6] text-[15px]">Value</div>
            <div className="text-white text-[15px] text-right font-semibold">
              {rule.condition?.value}
            </div>
            <div className="text-[#AEBCC6] text-[15px]">Time Window</div>
            <div className="text-white text-[15px] text-right font-semibold">
              {rule.condition?.timeWindow}
            </div>
            <div className="text-[#AEBCC6] text-[15px]">Notes</div>
            <div className="text-white text-[15px] text-right font-semibold">
              {rule.notes}
            </div>
            <div className="text-[#AEBCC6] text-[15px]">Created By</div>
            <div className="text-white text-[15px] text-right font-semibold">
              {rule.createdBy}
            </div>
            <div className="text-[#AEBCC6] text-[15px]">Created At</div>
            <div className="text-white text-[15px] text-right font-semibold">
              {rule.createdAt}
            </div>
            <div className="text-[#AEBCC6] text-[15px]">Updated At</div>
            <div className="text-white text-[15px] text-right font-semibold">
              {rule.updatedAt}
            </div>
            <div className="text-[#AEBCC6] text-[15px]">Rule ID</div>
            <div className="text-white text-[15px] text-right font-semibold">
              {rule._id}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RuleDetailsModal;
